"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const NativeSelect_1 = __importDefault(require("../../../common/js/atoms/NativeSelect"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const locale_1 = require("../../../common/js/helper/locale");
const noop_1 = require("../../../common/js/helper/noop");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const Paths_1 = require("../../constants/Paths");
const locale_2 = require("../../helper/locale");
const AccountStore_1 = __importDefault(require("../../stores/AccountStore"));
const MassiveCompany_1 = __importDefault(require("../../stores/MassiveCompany"));
const UiStore_1 = __importDefault(require("../../stores/UiStore"));
const UserProfileAccountPersonalData_1 = __importDefault(require("./UserProfileAccountPersonalData"));
class UserProfileAccount extends react_1.default.Component {
    languageSubmitted = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            languageSubmitted: mobx_1.observable,
            languages: mobx_1.computed,
            options: mobx_1.computed,
        });
    }
    get languages() {
        return new Intl.DisplayNames(i18next_1.default.language, {
            type: 'language',
        });
    }
    get options() {
        return Object.keys(__APP__.LOCALE_MAP ?? {}).map((key) => {
            return {
                label: this.languages.of(key) ?? key,
                value: key,
            };
        });
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('profile_subpage_title', { title: (0, translation_1.t)('user.profile.account.title') });
    }
    render() {
        if (MassiveCompany_1.default.isLoading) {
            return (react_1.default.createElement("div", { className: "h-100 d-flex align-items-center justify-content-center" },
                react_1.default.createElement(LoadingSpinner_1.default, null)));
        }
        return (react_1.default.createElement("section", { className: "znd-user-profile-page__content" },
            react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.COMPANY_READ] },
                react_1.default.createElement(UserProfileAccountPersonalData_1.default, null)),
            this.languageSubmitted ? (react_1.default.createElement("div", { className: "h-100 d-flex align-items-center justify-content-center" },
                react_1.default.createElement(LoadingSpinner_1.default, null))) : (this.renderLanguage())));
    }
    renderLanguage() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h2", { className: "znd-user-profile-page__content-data-title t-headline-3" }, (0, translation_1.t)('user.profile.settings.title')),
            react_1.default.createElement("div", { className: "znd-user-profile-page__content-data-group" },
                react_1.default.createElement("div", { className: "znd-user-profile-page__content-data-item" },
                    react_1.default.createElement("div", { className: "znd-address__headline t-subhead-small mb-2" }, (0, translation_1.t)('user.profile.settings.language.label')),
                    react_1.default.createElement(NativeSelect_1.default, { required: true, onChange: (0, mobx_1.action)((value) => {
                            const languageId = (0, locale_2.getLanguageIdFromLocale)(value);
                            this.languageSubmitted = true;
                            this.props.history.push(Paths_1.PATH_USER_PROFILE_ACCOUNT.replace(':locale', value));
                            if (!languageId) {
                                return;
                            }
                            AccountStore_1.default.updateAccount({ languageId })
                                .catch(noop_1.noop)
                                .finally(() => {
                                if (!AuthorizationStore_1.default.auth0?.isAuthenticated) {
                                    return;
                                }
                                // Refreshing access token to ensure language changes are available in the token.
                                return AuthorizationStore_1.default.auth0.getAccessTokenSilently({ ignoreCache: true });
                            })
                                .finally((0, mobx_1.action)(() => {
                                this.languageSubmitted = false;
                            }));
                        }), options: this.options, placeholder: (0, translation_1.t)('user.profile.settings.language.placeholder'), value: (0, locale_1.getLanguageFromLocale)(UiStore_1.default.language) ?? '' })))));
    }
}
exports.default = (0, mobx_react_1.observer)(UserProfileAccount);
